import { Button, ButtonProps, styled } from '@mui/material';

interface MainButtonProps extends ButtonProps {
    grayed?: boolean;
    colors?: string[];
    angle?: string;
    textcolor: string;
}

const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'grayed',
})<MainButtonProps>(({ theme, colors, angle = 90, textcolor = 'white' }) => ({
    background: `linear-gradient(${angle}deg, ${colors})`,
    border: `0px`,
    borderRadius: 100,
    fontSize: 14,
    color: textcolor,
    padding: '8px 13px',
    textTransform: 'capitalize',    
    '&.MuiButton-sizeSmall': {
        padding: '4px 24px',
        fontSize: 14,
        fontWeight: 600,
    },
    '&.Mui-disabled': {
        opacity: 1,
        color: textcolor
    },
}));

const GradientButton = ((props: MainButtonProps) => {
    const { children, ...otherProps } = props;
    return (
        <StyledButton {...otherProps}>
            {children}
        </StyledButton>
    );
});

export default GradientButton;
